import React from 'react';
import CheckmarkIcon from '../../assets/icons/CheckmarkIcon';
import useTheme from '../../hooks/ui/useTheme';
import { RewardInterface } from '../../services/exports/Interfaces';
import { useTranslation } from 'react-i18next';
import useRewardAccount from '../../hooks/loyalty/useRewardAccount';
import classnames from 'classnames';

interface Props {
  data: RewardInterface;
}

export default function DiscountCircleLabel({ data }: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Rewards:DiscountCircleLabel' });

  const { balance, availableReward } = useRewardAccount();

  const theme = useTheme();
  const isUsed = data.cost <= balance && !data.is_available;
  const isActive = data.id === availableReward?.id;

  return (
    <div className={container} style={{ opacity: isUsed ? 0.5 : 1 }}>
      <div className={classnames(circleContainer, { '!bg-brand-primary': isUsed || isActive })}>
        <h6 className={classnames('text-sm font-medium text-brand-primary', { 'text-white': isUsed || isActive })}>
          {data.discount === 100 ? t('free') : `${data.discount}%`}
        </h6>
      </div>
      <div className={pointsRow}>
        <p className="text-sm">{t('point', { count: data.cost })}</p>
        {data.is_available && !isUsed && (
          <div className={checkmarkContainer}>
            <CheckmarkIcon color={theme.color.white['100']} className="h-2 w-2" />
          </div>
        )}
      </div>
    </div>
  );
}

const container = 'flex flex-col items-center';

const pointsRow = 'flex flex-row items-center mt-xs';

const checkmarkContainer = 'w-4 h-4 rounded-full flex justify-center items-center ml-2xs bg-brand-primary';

const circleContainer =
  'w-[56px] h-[54px] bg-transparent border border-brand-primary rounded-full flex justify-center items-center';
